import CryptoJS from 'crypto-js'
import store from '@/store'
import Aces from '@/uilts/Aces'

// 数据处理函数
function privacy(params) {
    params = params || {}
    // 添加公共参数
    params['time_stamp'] = new Date().getTime()
    // 加密计算
    const sign = CryptoJS.MD5(String(params.time_stamp).slice(9) + splicing_params(params) + store.state.SIGN_KEY).toString()
    // console.log(splicing_params(params))
    params['sign'] = sign.split('').reverse().join('')
    // console.log(params)
    const requestParams = Aces.Encrypt(JSON.stringify(params))
    return requestParams
}

// 数据处理函数（上传）
function privacyUpload(params) {
    params = params || {}
    // 添加公共参数
    params['time_stamp'] = new Date().getTime()
    // 加密计算
    const sign = CryptoJS.MD5(String(params.time_stamp).slice(9) + splicing_params(params) + store.state.SIGN_KEY).toString()
    params['sign'] = sign.split('').reverse().join('')
    return params
}

// 拼接参数
function splicing_params(params) {
    const arr = []
    let num = 0
    for (const i in params) {
        arr[num] = i
        num++
    }
    const sortArr = arr.sort()
    let str = ''
    for (const i in sortArr) {
        if (params[sortArr[i]] !== '') {
            var value = Array.isArray(params[sortArr[i]]) ? JSON.stringify(params[sortArr[i]]) : params[sortArr[i]]
            str += sortArr[i] + '=' + value + '&'
        }
    }
    const char = '&'
    str = str.replace(new RegExp('^\\' + char + '+|\\' + char + '+$', 'g'), '')
    return str
}

export {
    privacy,
    privacyUpload
}